import Vue from 'vue';
import Vuex from 'vuex';

// TODO: 모듈 분리한 의미가 없음 지금 리팩토링 개같이 해야 됨
import global from './modules/global';
import user from './modules/user';
import home from './modules/home';
import channel from './modules/channel';
import post from './modules/post';
import product from './modules/product';
import lecture from './modules/lecture';
import community from './modules/community';
import tour from './modules/tour';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: false,
  modules: {
    global, user, home, channel, post, product, lecture, community, tour
  },
});

export default store;
